var exports = {
  "I": "markerMenuOverlay__Dz5L3-",
};

module.exports = exports;
